<template>
  <a-select
    mode="multiple"
    v-model="model"
    :defaultValue="[]"
    style="width: 100%"
    :filterOption="false"
    @search="handleSearch"
    @change="handleChange"
    :placeholder="placeholder"
  >
    <a-select-option style="width：80%" v-for="option in options" :key="option.id">{{option.name}}</a-select-option>
  </a-select>
</template>
<script>
import { getUserOptions } from '@/api/user'
export default {
  name: 'UsersPicker',
  data() {
    return {
      //        model:undefined,
      options: [] // [{name:"张三",id:1}]
    }
  },
  props: {
    formData: {
      type: Object,
      required: true
    },
    field: {
      type: String | Number, //user_list [1]
      required: true
    },
    // limit: {
    //   type: Number,
    //   default: 100
    // },
    placeholder: {
      type: String,
      default: '请选择用户'
    }, 
  },
  computed: {
    model: {
      get: function() {
        return this.formData[this.field]
      },
      set: function() {}
    }
  },
  watch: {},
  created() { },
  methods: {
    handleSearch(value) {
      let that = this
      getUserOptions({ keywords: value }).then(res => {
        console.log(res.data)
        that.options = res.data
        console.log(that.options)
      })
    },
    handleChange(value) {
      this.formData[this.field] = value
    }

    // handleChange(value) {
    //     console.log(value)
    //   console.log(`selected ${value}`);
    // }
  }
}
</script>
<style>
</style>